import {PopupViewElement} from './popup-view.component';

export class PopupButtonElement extends HTMLButtonElement {
  private readonly _popupId: string | undefined;
  private readonly _popup?: PopupViewElement | null;


  constructor() {
    super();

    this._popupId = this.dataset.popup;

    if (!this._popupId) {
      console.warn('Missing data-popup attribute', this);
      return;
    }

    const popup = document.querySelector<PopupViewElement>('#' + this._popupId);
    this._popup = popup;

    if (!popup) {
      console.warn('Missing popup-view component', this);
      return;
    }

    this.addEventListener('click', () => popup.open());
  }

  connectedCallback() {

  }
  disconnectedCallback() {
  }
}

window.customElements.define('popup-button', PopupButtonElement, {extends: 'button'});
